"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.authReducer = exports.setLoading = exports.clearCredentials = exports.updateUser = exports.updateToken = exports.setCredentials = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var initialState = {
    user: null,
    token: "",
    expires_at: "",
    isAuthenticated: false,
    isLoading: true, // Start as loading to check localStorage on init
};
var authSlice = (0, toolkit_1.createSlice)({
    name: "auth",
    initialState: initialState,
    reducers: {
        setCredentials: function (state, action) {
            var _a = action.payload, user = _a.user, token = _a.token, expires_at = _a.expires_at;
            state.user = user;
            state.token = token;
            state.expires_at = expires_at;
            state.isAuthenticated = true;
            state.isLoading = false;
        },
        updateToken: function (state, action) {
            state.token = action.payload.token;
            state.expires_at = action.payload.expires_at;
        },
        updateUser: function (state, action) {
            state.user = action.payload;
        },
        clearCredentials: function (state) {
            state.user = null;
            state.token = "";
            state.expires_at = "";
            state.isAuthenticated = false;
            state.isLoading = false;
        },
        setLoading: function (state, action) {
            state.isLoading = action.payload;
        },
    },
});
exports.setCredentials = (_a = authSlice.actions, _a.setCredentials), exports.updateToken = _a.updateToken, exports.updateUser = _a.updateUser, exports.clearCredentials = _a.clearCredentials, exports.setLoading = _a.setLoading;
exports.authReducer = authSlice.reducer;
